import type { ReactNode } from 'react'
import { cx } from '../cx'
import styles from './EmptyState.module.css'

type EmptyStateProps = { action?: ReactNode; className?: string } & (
  | {
      variant?: 'block'
      title: string
      /** The block is the route's heading when it fills the page (D89). */
      titleAs?: 'h1' | 'h2' | 'h3'
      description?: ReactNode
    }
  | { variant: 'inline'; description: ReactNode; title?: never }
)

export function EmptyState(props: EmptyStateProps) {
  const { action, className } = props

  if (props.variant === 'inline') {
    return (
      <div className={cx(styles.inline, className)} data-variant="inline">
        <p className={styles.sentence}>{props.description}</p>
        {action}
      </div>
    )
  }

  const { title, titleAs: Title = 'h3', description } = props
  return (
    <div className={cx(styles.block, className)} data-variant="block">
      <Title className={styles.title}>{title}</Title>
      {description != null && (
        <p className={styles.description}>{description}</p>
      )}
      {action}
    </div>
  )
}
